import { render, staticRenderFns } from "./EipAttachment.vue?vue&type=template&id=4f2d21b0&scoped=true&"
import script from "./EipAttachment.vue?vue&type=script&lang=js&"
export * from "./EipAttachment.vue?vue&type=script&lang=js&"
import style0 from "./EipAttachment.vue?vue&type=style&index=0&id=4f2d21b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d21b0",
  null
  
)

export default component.exports